export default __webpack_public_path__ + "static/media/ssdrone-cut.3f2a7d92.mp4";